const SearchIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.57642 2.18376C3.93853 2.18376 2.61076 3.51153 2.61076 5.14941C2.61076 6.7873 3.93853 8.11507 5.57642 8.11507C7.2143 8.11507 8.54207 6.7873 8.54207 5.14941C8.54207 3.51153 7.2143 2.18376 5.57642 2.18376ZM1.76343 5.14941C1.76343 3.04356 3.47056 1.33643 5.57642 1.33643C7.68227 1.33643 9.3894 3.04356 9.3894 5.14941C9.3894 7.25527 7.68227 8.9624 5.57642 8.9624C3.47056 8.9624 1.76343 7.25527 1.76343 5.14941Z"
        fill="#707087"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.67055 7.24355C7.836 7.07809 8.10425 7.07809 8.2697 7.24355L10.1126 9.08649C10.2781 9.25194 10.2781 9.52019 10.1126 9.68565C9.9472 9.8511 9.67894 9.8511 9.51349 9.68565L7.67055 7.8427C7.5051 7.67725 7.5051 7.409 7.67055 7.24355Z"
        fill="#707087"
      />
    </svg>
  );
};

export default SearchIcon;
